module.exports = __webpack_public_path__ + "static/media/20170806_06day_0245AT.d331bd66.jpg";